/**
 * Of deze pagina in de Mac-app draait (de schil biedt `window.novamundDesktop.openBestand`), of in een browser of op de
 * telefoon. Eerst in BijlageKaart (J7); sinds CA3 hier, zodat ook het voorbeeld van een server het kan vragen zonder de
 * hele bijlagekaart mee te laden.
 */
export const opDeMac = () => typeof window !== "undefined" && typeof window.novamundDesktop?.openBestand === "function";

/** Een bestand (naam, inhoud in base64) via de schil in Downloads zetten en openen. Sinds CA6 hier, met de export. */
export async function openOpDeMac(att) {
  try {
    return (await window.novamundDesktop.openBestand(att?.name || "bijlage", att?.data || "")) || { fout: "leeg" };
  } catch {
    return { fout: "brug" };
  }
}
